export const array = (value) => {
    return value instanceof Array;
};
